import styled from "styled-components";
import { type WidthProps, width } from "styled-system";
import * as CommonButton from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as MonthlyPrice from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/MonthlyPrice";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { ImageFluid } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Image";

export const CarWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
    padding: ${theme.space[3]}px;
    border: 1px solid ${theme.colors.grey2};

    ${MonthlyPrice.Text} {
        font-weight: bold;
    }

    ${ImageFluid} {
        margin: 0 auto;
    }

    ${CommonButton.Primary} {
        margin-top: auto;
    }
`;

export const PriceContainer = styled.div`
    margin-top: ${theme.space[1]}px;
    line-height: 1.4;
`;

export const Button = styled(CommonButton.Secondary)`
    max-width: 100%;
    padding: 0 29px 5px 29px; /* fix to improve vertical-alignment button */
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const CTAContainer = styled.div<WidthProps>`
    ${width}
    text-align: center;
`;
